import React from 'react';
import { RoomDesignCalculationsResponse } from '../../../../../designs/design-form/calculations/designCalculationsResponse';
import { DesignMaterialsCalculationsRequest } from '../../../../../designs/design-form/calculations/materials/designMaterialsCalculationsResponse';
import { ManifoldFormModel } from '../../../manifolds/manifoldFormModel';
import { DesignFormUnitViewType } from '../../../units/unitFormModel';
import { RoomFormModel } from '../../roomFormModel';
import { RoomAutocompleteItem, RoomType } from '../../roomTypes';
import { RoomFieldsBasic } from './RoomFieldsBasic';
import { RoomFieldsCad } from './RoomFieldsCad';
import { RoomFieldsPerformance } from './RoomFieldsPerformance';
import { RoomFieldsOther } from './RoomFieldsOther';
import { RoomFieldsThermostats } from './RoomFieldsThermostats';

type Props = {
  unitViewType: DesignFormUnitViewType;
  unitIndex: number;
  manifoldIndex: number;
  manifold: ManifoldFormModel;
  roomIndex: number;
  room: RoomFormModel;
  handleSelectionOfRoomName: (selectedItem: RoomAutocompleteItem) => void;
  handleSelectionOfRoomType: (selectedType: RoomType) => void;
  roomDesignCalculationsResponse: RoomDesignCalculationsResponse | null;
  designMaterialsCalculationsRequest?: DesignMaterialsCalculationsRequest;
};

export const DesignRoomFields = ({
  unitViewType,
  unitIndex,
  manifoldIndex,
  manifold,
  roomIndex,
  room,
  handleSelectionOfRoomName,
  handleSelectionOfRoomType,
  roomDesignCalculationsResponse,
  designMaterialsCalculationsRequest,
}: Props) => {
  if (unitViewType === 'Basic') {
    return (
      <RoomFieldsBasic
        unitIndex={unitIndex}
        manifoldIndex={manifoldIndex}
        roomIndex={roomIndex}
        isWithinRadiatorManifold={manifold.isRadiator}
        room={room}
        handleSelectionOfRoomName={handleSelectionOfRoomName}
        handleSelectionOfRoomType={handleSelectionOfRoomType}
      />
    );
  }

  if (unitViewType === 'Performance') {
    return (
      <RoomFieldsPerformance
        unitIndex={unitIndex}
        manifoldIndex={manifoldIndex}
        manifold={manifold}
        roomIndex={roomIndex}
        isWithinRadiatorManifold={manifold.isRadiator}
        room={room}
        handleSelectionOfRoomName={handleSelectionOfRoomName}
      />
    );
  }

  if (unitViewType === 'Thermostats') {
    return (
      <RoomFieldsThermostats
        unitIndex={unitIndex}
        manifoldIndex={manifoldIndex}
        manifold={manifold}
        roomIndex={roomIndex}
        isWithinRadiatorManifold={manifold.isRadiator}
        room={room}
        handleSelectionOfRoomName={handleSelectionOfRoomName}
      />
    );
  }

  if (unitViewType === 'Cad') {
    return (
      <RoomFieldsCad
        unitIndex={unitIndex}
        manifoldIndex={manifoldIndex}
        roomIndex={roomIndex}
        isWithinRadiatorManifold={manifold.isRadiator}
        room={room}
        handleSelectionOfRoomName={handleSelectionOfRoomName}
        designMaterialsCalculationsRequest={designMaterialsCalculationsRequest}
      />
    );
  }

  if (unitViewType === 'Other') {
    return (
      <RoomFieldsOther
        unitIndex={unitIndex}
        manifoldIndex={manifoldIndex}
        roomIndex={roomIndex}
        isWithinRadiatorManifold={manifold.isRadiator}
        room={room}
        handleSelectionOfRoomName={handleSelectionOfRoomName}
        roomDesignCalculationsResponse={roomDesignCalculationsResponse}
      />
    );
  }

  return null;
};
